<template>
  <main>
    <div class="list_articles">
      <div class="row">
        <div class="col-sm-12">
          <TopTemplate>
            <template v-slot:left-element>
              <h3>{{ $t("title.listActualites") }} ({{ total }})</h3>
              
            </template>

            <template v-slot:right-element>
              <b-button @click="oppenModalAdd()" class="btn button btn-primary"><i class="icon-Add" /> Ajouter actualité</b-button>
            </template>
          </TopTemplate>
        </div>
      </div>
    </div>

    <div class="row container-select container-filter">
      <div v-if="params.title || params.date || params.category" class="col-sm-12">
        <div class="reset_student" @click="resetFilter()">
          <i class="icon-reset" />
          {{ $t("barFiltre.renitialiser") }}
        </div>
      </div>
      <div class="col-sm-12 sub-title">
        <h3>Chercher dans les actualités</h3>
        </div>
      <div class="col-sm-4 select-wrapper simple-input">
        <span class="title-select">{{ $t("barFiltre.title") }}</span>
        <input type="text" v-model="params.title" class="form-control article_filtre" @input="searshByTitle" />
      </div>
      <div class="col-sm-4 select-wrapper">
        <span class="title-select">{{ $t("barFiltre.date") }}</span>
        <div class="date-wrapper">
          <Datepicker v-model="params.date" autoApply locale="fr" :enable-time-picker="false" :format="format_date_v1" @update:modelValue="handleInput($event)" />
        </div>
      </div>
      <div class="col-sm-4 col-12 select-wrapper">
        <span class="title-select">{{ $t("barFiltre.categories") }}</span>
        <v-select
          v-model="params.category"
          :options="categories"
          :searchable="false"
          label="name"
          class="form-control"
          :multiple="true"
          :reduce="(option) => option.id"
          @update:modelValue="ChangeClass($event)"
        >
          <template #no-options="{search, searching, loading}">
            {{ $t("info.noResult") }}
          </template>
        </v-select>
      </div>
    </div>

    <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
      <div class="spinner-border text-info" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div v-if="!loading && articles.length == 0" class="container-fluid empty-message card mt-4" >
          <div class="col-12 empty-result text-center pt-3">
            <p>{{ $t("common.emptysearshArticle") }}</p>
          </div>
    </div>
    <div class="table category article-table" v-if="!loading && articles.length > 0">
      <div class="table__wrapper table-responsive-vertical table-responsive">
        <table class="table table_article">
          <thead>
            <tr>
              <th class="col-md-2">
                {{ $t("article.title") }}
                <div class="icon-wrapper">
                  <div class="icon-wrapper" @click="sortB('title')">
                    <i class="ri-arrow-up-s-line" :class="[specTri('title', true)]" />
                    <i class="ri-arrow-down-s-line" :class="[specTri('title', false)]" />
                  </div>
                </div>
              </th>
              <th class="col-md-4">{{ $t("article.contenu") }}</th>
              <th class="col-md-2">{{ $t("article.categorie") }}</th>
              <th class="col-md-2">{{ $t("article.date") }}</th>
              <th class="col-md-2">{{ $t("common.actions") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="article in articles" :key="article.id">
              <td class="col-md-2" :class="{'arabic-text': checkLanguag(article.title)}">
                <span v-if="article.title" class="title-articl-list">{{ article.title }}</span
                ><span v-else>__</span>
              </td>
              <td class="col-md-4"><span v-if="article.content" v-html="article.content" class="content-editor item-content-editor"></span><span v-else>__</span></td>

              <td class="col-md-2">
                <span v-if="article.categorys.length">{{ arrayToString(article.categorys) }}</span
                ><span v-else>__</span>
              </td>
              <td class="col-md-2">
                <span v-if="article.start">{{ format_date_v1(article.start) }}</span
                ><span v-else>__</span>
              </td>
              <td class="col-md-2">
                <div style="height: 16px">
                  <router-link
                    :to="{
                      name: 'DetailsArticle',
                      params: {
                        id: article.id,
                      },
                    }"
                    class
                  >
                    <i class="icon-eyes">
                      <span class="tooltiptext">{{ $t("button.tooltip.details") }}</span>
                    </i>
                  </router-link>

                  <a @click="articleById(article.id)">
                    <i class="icon-edit-02">
                      <span class="tooltiptext">{{ $t("button.tooltip.update") }}</span>
                    </i>
                  </a>
                  <i class="icon-trash" @click.prevent="deleteArticle(article.id)">
                    <span class="tooltiptext">{{ $t("button.tooltip.delete") }}</span>
                  </i>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="table__wrapper__pagination-wrapper">
          <div class="pagination">
            <pagination v-if="last_page > 1" :dataSet="pagination" @goToPage="getResults" />
          </div>
        </div>
      </div>
    </div>
    <!-- modal -->
    <b-modal v-model="showModalAdd" centered title="Ajouter une actualité" class="modal-full-screen modal-article" style="padding: 16px 30px" hide-footer>
      <form @submit.prevent="onSubmitAddArticle" novalidate>
        <div class="row form-modal">
          <div class="col-xl-6 col-lg-12 col-md-4 col-sm-4 col-xs-12 simple-input mt-4">
            <label class="style-label">
              {{ $t("article.title") }}
              <sup>*</sup>
            </label>
            <div>
              <input type="text" v-model="form.title" class="form-control" :class="v$.form.title.$error ? 'is-invalid' : ''" />
              <span class="invalid-feedback" v-if="v$.form.title.$error">
                {{ v$.form.title.$errors[0].$message }}
              </span>
            </div>
          </div>
          <div class="col-xl-6 col-lg-12 col-md-4 col-sm-4 col-xs-12 simple-input mt-4">
            <label class="style-label">
              {{ $t("article.date") }}
              <sup>*</sup>
            </label>
            <div class="date-wrapper">
              <Datepicker v-model="form.start" autoApply locale="fr" :enable-time-picker="false" :format="format_date_v1" @update:modelValue="handleInput($event)" />
              <span class="invalid-feedback" v-if="v$.form.start.$error">
                {{ v$.form.start.$errors[0].$message }}
              </span>

            </div>
          </div>

          <div class="col-xl-6 col-lg-12 col-md-4 col-sm-4 col-xs-12 select-wrapper mt-4">
            <label class="style-label">{{ $t("article.photo") }}</label>
            <label class="input-image" for="otherDoc" @change="onFileChange">
              <div class="file-name">
                <span class="justify--" v-if="imageName">
                  {{ imageName }}
                </span>
                <span class="justify--- err article" v-else> {{ $t("info.download") }} </span>
              </div>

              <div class="icon-upload">
                <img src="../../assets/icons/VectorMsg.svg" />
              </div>
              <input id="otherDoc" type="file" class="d-none" accept=".png, .jpg, .jpeg" tabindex="-1" />
            </label>
            <label class="indice">{{ $t("info.sizeImage") }}</label>
            <span v-if="errorDocSize" class="indice errorSizeDoc">{{ $t("error.errorTailleMsg") }}</span>
          </div>
          <div class="col-xl-6 col-lg-12 col-md-4 col-sm-4 col-xs-12 select-wrapper mt-4">
            <label class="style-label">
              {{ $t("article.categorie") }}
              <sup>*</sup>
            </label>
            <div>
              <v-select
                v-model="form.categoriesId"
                :options="categories"
                :searchable="true"
                label="name"
                :multiple="true"
                :reduce="(option) => option.id"
                :class="v$.form.categoriesId.$error ? 'is-invalid' : ''"
              >
                <template #no-options="{search, searching, loading}"> {{ $t("info.noResult") }}</template>
              </v-select>
              <span class="invalid-feedback" v-if="v$.form.categoriesId.$error">
                {{ v$.form.categoriesId.$errors[0].$message }}
              </span>
            </div>
          </div>
          <div class="col-12 style-editor mt-4">
            <label class="style-label">
              {{ $t("article.contenu") }}
              <sup>*</sup>
            </label>
            <TinycmeEditor v-model="form.content" :class="v$.form.content.$error ? 'is-invalid' : ''" />
            <span class="invalid-feedback" v-if="v$.form.content.$error">
              {{ v$.form.content.$errors[0].$message }}
            </span>
          </div>
          <div class="col-12 buttons btn-action-modal my-4">
            <button type="submit" class="btn button btn-primary right-btn" :disabled="isSubmitted"><i class="icon-Check"></i>{{ $t("button.add") }}</button>
            <button @click="cancelAddArticle()" class="btn btn-outline-primary button left-btn"><i class="icon-Add"></i>{{ $t("button.annuler") }}</button>
          </div>
        </div>
      </form>
    </b-modal>
    <b-modal v-model="showModalEdit" centered title="Modifier l'actualité" class="modal-full-screen modal-article" style="padding: 16px 30px" hide-footer>
      <div v-if="loadingData" class="card mt-4 text-center d-block pt-4 pb-4">
        <div class="spinner-border text-info" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <form v-if="!loadingData" @submit.prevent="onSubmitEditArticle" novalidate>
        <div class="row form-modal">
          <div class="col-xl-6 col-lg-12 col-md-4 col-sm-4 col-xs-12 simple-input mt-4">
            <label class="style-label">
              {{ $t("article.title") }}
              <sup>*</sup>
            </label>
            <div>
              <input type="text" v-model="form.title" class="form-control" :class="v$.form.title.$error ? 'is-invalid' : ''" />
              <span class="invalid-feedback" v-if="v$.form.title.$error">
                {{ v$.form.title.$errors[0].$message }}
              </span>
            </div>
          </div>
          <div class="col-xl-6 col-lg-12 col-md-4 col-sm-4 col-xs-12 simple-input mt-4">
            <label class="style-label">
              {{ $t("article.date") }}
              <sup>*</sup>
            </label>
            <div class="date-wrapper">
              <Datepicker v-model="form.start" autoApply :enable-time-picker="false" locale="fr" :format="format_date_v1" @update:modelValue="handleInput($event)" />
              <span class="invalid-feedback" v-if="v$.form.start.$error">
                {{ v$.form.start.$errors[0].$message }}
              </span>
            </div>
          </div>
          <div class="col-xl-6 col-lg-12 col-md-4 col-sm-4 col-xs-12 select-wrapper mt-4">
            <label class="style-label">{{ $t("article.photo") }}</label>
            <label class="input-image" for="otherDoc" @change="onFileChange">
              <div class="file-name">
                <span class="justify--" v-if="imageName">
                  {{ imageName }}
                </span>
                <span class="justify--- err article" v-else> {{ $t("info.download") }} </span>
              </div>
              <div class="icon-upload">
                <img src="../../assets/icons/VectorMsg.svg" />
              </div>
              <input id="otherDoc" type="file" class="d-none" accept=".png, .jpg, .jpeg" tabindex="-1" />
            </label>
            <label class="indice">{{ $t("info.sizeImage") }}</label>
            <span v-if="errorDocSize" class="indice errorSizeDoc">{{ $t("error.errorTailleMsg") }}</span>
          </div>
          <div class="col-xl-6 col-lg-12 col-md-4 col-sm-4 col-xs-12 select-wrapper mt-4">
            <label class="style-label">
              {{ $t("barFiltre.categories") }}
              <sup>*</sup>
            </label>
            <div>
              <v-select
                v-model="form.categoriesId"
                :options="categories"
                :searchable="true"
                label="name"
                :multiple="true"
                class="form-control"
                :reduce="(option) => option.id"
                :class="v$.form.categoriesId.$error ? 'is-invalid' : ''"
              >
                <template #no-options="{search, searching, loading}">
                  <div class="card mt-2 text-center d-block pt-2 pb-2">
                    <div class="spinner-border text-info" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>
                </template>
              </v-select>
              <span class="invalid-feedback" v-if="v$.form.categoriesId.$error">
                {{ v$.form.categoriesId.$errors[0].$message }}
              </span>
            </div>
          </div>
          <div class="col-12 style-editor mt-4">
            <label class="style-label">
              {{ $t("article.contenu") }}
              <sup>*</sup>
            </label>
            <TinycmeEditor v-model="form.content" :class="v$.form.content.$error ? 'is-invalid' : ''" />
            <span class="invalid-feedback" v-if="v$.form.content.$error">
              {{ v$.form.content.$errors[0].$message }}
            </span>
          </div>
          <div class="col-12 buttons btn-action-modal my-4">
            <button type="submit" class="btn button btn-primary right-btn" :disabled="isSubmitted"><i class="icon-Check"></i>{{ $t("button.envoi") }}</button>
            <button @click="cancelEditArticle()" class="btn btn-outline-primary button left-btn"><i class="icon-Add"></i>{{ $t("button.annuler") }}</button>
          </div>
        </div>
      </form>
    </b-modal>
  </main>
</template>
<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import pagination from "../../components/navigation/Pagination";
import ArticlesService from "../../services/article.service";
import CategorieService from "../../services/categorie.service";
import useValidate from "@vuelidate/core";
import {required, helpers, maxLength} from "@vuelidate/validators";
import vSelect from "vue-select";
import moment from "moment";
import Datepicker from "@vuepic/vue-datepicker";
import {ref} from "vue";
import "@vuepic/vue-datepicker/dist/main.css";
import _ from "lodash";
import TinycmeEditor from "../../components/tinymce.vue";
const SIZE_IMAGE = 2;
export default {
  name: "ArticlesPage",
  components: {
    TopTemplate,
    pagination,
    "v-select": vSelect,
    Datepicker,
    TinycmeEditor,
  },

  data() {
    return {
      loading: false,
      total: 0,
      file: null,
      v$: useValidate(),
      pagination: {},
      isSubmitted: false,
      params: {
        limit: 10,
        page: 1,
        sort: "created_at",
        order: false,
        title: "",
        category: null,
        start: null,
        date: null,
      },
      articles: [],
      errorDocSize: false,
      showModalAdd: false,
      showModalEdit: false,
      fileUrl: "",
      loadingData: false,
      categoryId: null,
      isCancel: false,
      isCancelAdd: false,
      last_page: null,
      categories: [],
      form: {
        title: "",
        photo: null,
        categoriesId: [],
        content: "",
        start: ref(new Date()),
      },
      categoriesTab: [],
      imageName: "",
    };
  },
  validations() {
    return {
      form: {
        title: {
          required: helpers.withMessage(this.$t("validation.required"), required),
          maxLength: maxLength(100),
        },
        categoriesId: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        content: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
        start: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
      },
    };
  },
  computed: {},
  created() {
    this.articlesList();
    this.categoriesList();
  },
  mounted() {},
  methods: {
    format_date_v1(value) {
      if (value) {
        return moment(String(value)).format("DD-MM-YYYY");
      }
    },
    resetForm() {
      this.errorDocSize = null;
      this.imageName = null;

      this.form = {
        title: "",
        photo: null,
        photo_name: null,
        start: ref(new Date()),
        categoriesId: [],
        content: "",
      };
      this.validations;
    },
    arrayToString(data) {
      let receivers = "";
      if (data.length) {
        receivers = data
          .map((ele) => {
            return ele.name;
          })
          .join(", ");
      }
      return receivers;
    },
    dateTime(value) {
      return moment(value).locale("fr").format("YYYY-MM-DD");
    },
    handleInput() {
      if (this.params.date != null) {
        this.params.date = this.dateTime(this.params.date);
      }
      this.getResults();
    },
    ChangeClass(e) {
      this.params.category = e;
      this.getResults();
    },
    checkFilesSize: _.throttle(function (file) {
      if (!file) {
        this.errorDocSize = false;
      }
      this.errorDocSize = file.size / 1024 / 1024 > SIZE_IMAGE;
    }, 300),
    onFileChange(e) {
      let file = e.target.files[0];
      this.imageName = file.name;
      let reader = new FileReader();
      reader.onloadend = (file) => {
        const files = e.target.files[0];
        this.checkFilesSize(files);
        this.form.photo = reader.result;
      };
      reader.readAsDataURL(file);
    },
    categoriesList() {
      this.loading = true;
      CategorieService.getAll()
        .then((res) => {
          this.categories = _.orderBy(res.data.data, "name");
        })
        .catch((error) => {
          console.error(error);
        });
    },
    searshByTitle: _.debounce(function () {
      if (this.params.title.toString().length > 1 || !this.params.title.toString().length) {
        this.params.hasfilter = true;
        this.getResults();
      }
    }, 200),
    resetFilter() {
      this.params.title = null;
      this.params.category = null;
      this.params.date = null;
      this.getResults();
    },
    deleteArticle(id) {
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm  btn-primary",
          cancelButton: "btn  btn-cancel  btn-outline-primary",
        },
        buttonsStyling: false,
        showCloseButton: true,
      });
      swalWithBootstrapButtons
        .fire({
          title: this.$t("common.confirmDeleteArticle"),
          icon: "warning",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(this.$t("common.articleDeleted"), "", "success");
            ArticlesService.delete(id)
              .then(() => {
                this.getResults();
              })
              .finally(() => {
                this.loading = false;
              });
          }
        });
    },
    specTri(param, order) {
      if (this.params.order === null && this.params.sort === "") {
        return "";
      } else {
        if (this.params.sort === param) {
          if (this.params.order === order) {
            return "ordredA";
          } else {
            return "ordredD";
          }
        } else {
          return "";
        }
      }
    },
    sortB: _.debounce(function (param) {
      this.params.order = this.params.order === false ? true : false;
      this.params.sort = param;
      this.articlesList();
    }, 200),
    sort(order, sort) {
      this.params.order = order;
      this.params.sort = sort;
      this.articlesList();
    },
    articlesList() {
      this.loading = true;
      ArticlesService.getAll({
        params: {
          limit: this.params.limit,
          sort: this.params.sort,
          order: this.params.order,
          category_id: this.params.category,
          start: this.params.date,
          q: this.params.title,
        },
      })
        .then((res) => {
          this.articles = res.data.data;
          this.pagination = this.makePagination(res.data.meta, res.data.links);
          this.total = res.data.meta.total;
          this.last_page = res.data.meta.last_page;
        }).catch((error) => {
          if (error.response && error.response.status === 403) {
              this.$router.push('/error-403');
            }
         }).finally(() => {
          this.loading = false;
        });
    },
    makePagination(meta, links) {
      return {
        current_page: meta.current_page,
        last_page: meta.last_page,
        next_page_url: links.next,
        prev_page_url: links.prev,
      };
    },
    getResults(page = null) {
      this.params.page = !page ? this.params.page : page;
      this.loading = true;

      ArticlesService.getAll({
        params: {
          limit: this.params.limit,
          page: this.params.page,
          sort: this.params.sort,
          order: this.params.order,
          category_id: this.params.category,
          start: this.params.date,
          q: this.params.title,
        },
      })
        .then((response) => {
          this.articles = response.data.data;
          this.pagination = this.makePagination(response.data.meta, response.data.links);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    oppenModalAdd() {
      this.resetForm();
      setTimeout(() => {
        this.v$.$reset();
      }, 0);
      this.showModalAdd = !this.showModalAdd;
      this.isCancelAdd = false;
    },
    cancelAddArticle() {
      this.resetForm();
      setTimeout(() => {
        this.v$.$reset();
      }, 0);
      this.showModalAdd = !this.showModalAdd;
      this.isCancelAdd = true;
    },
    dateTime(value) {
      return moment(value).locale("fr").format("YYYY-MM-DD");
    },
    formatByDate: _.debounce(function () {
      if (this.due_date != null) {
        this.due_date = this.dateTime(this.due_date);
      }
    }, 200),
    onSubmitAddArticle() {
      this.v$.$validate();
      if (this.errorDocSize) {
        this.scrollToTop();
      }
      if (!this.errorDocSize && !this.v$.$error && !this.isCancelAdd) {
        this.isSubmitted = true;
        let data = {
          title: this.form.title,
          content: this.form.content,
          categorys: this.form.categoriesId,
          photo: this.form.photo,
          photo_name: this.imageName,
          start: moment(this.form.start).format("YYYY-MM-DD"),
        };
        /*  let formData = new FormData();
        formData.append("_method", "POST");
        formData.append("title", this.form.title);
        formData.append("content", this.form.content);
        formData.append("categorys", JSON.stringify(this.form.categoriesId));
        formData.append("start", moment(this.form.start).format("YYYY-MM-DD"));
        if (this.file) {
          formData.append("photo", this.file);
        } */
        ArticlesService.create(data)
          .then((res) => {
            this.resetForm();
            setTimeout(() => {
              this.v$.$reset();
            }, 0);
            this.articlesList();
          })
          .finally(() => {
            this.$nextTick(() => {
              this.isSubmitted = false;
              this.showModalAdd = false;
              this.v$.error = null;
            });
          });
      }
    },
    articleById(id) {
      this.loadingData = true;
      this.showModalEdit = !this.showModalEdit;
      this.categoryId = id;
      this.isCancel = false;
      ArticlesService.get(id)
        .then((res) => {
          this.form.title = res.data.title;
          this.form.categoriesId = res.data.categorys;
          this.form.content = res.data.content;
          this.form.photo = res.data.photo;
          this.imageName = res.data.photo_name;
        })
        .catch((error) => {
          console.error("error", error);
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    checkLanguag(val) {
      const arabic = /[\u0600-\u06FF]/;
      return arabic.test(val); // displays true
    },
    cancelEditArticle() {
      this.resetForm();
      setTimeout(() => {
        this.v$.$reset();
      }, 0);
      this.showModalEdit = !this.showModalEdit;
      this.isCancel = true;
    },
    onSubmitEditArticle() {
      this.v$.$validate();
      if (this.errorDocSize) {
        this.scrollToTop();
      }
      if (!this.errorDocSize && !this.v$.$error && !this.isCancel) {
        this.isSubmitted = true;
        this.categoriesTab = this.form.categoriesId.map((ele) => {
          return ele && ele.id ? ele.id : ele;
        });
        let data = {
          title: this.form.title,
          content: this.form.content,
          categorys: this.categoriesTab,
          photo: this.form.photo,
          photo_name: this.imageName,
          start: moment(this.form.start).locale("fr").format("YYYY-MM-DD"),
        };
        /*  let formData = new FormData();
        formData.append("_method", "POST");
        formData.append("title", this.form.title);
        formData.append("content", this.form.content);
        formData.append("categorys", JSON.stringify(this.categoriesTab));
        formData.append("start", moment(this.form.start).format("YYYY-MM-DD")); 
        if (this.file) {
          formData.append("photo", this.file);
        }else {
          formData.append("photo", this.fileUrl);
        }*/
        ArticlesService.update(this.categoryId, data)
          .then((res) => {
            setTimeout(() => {
              this.resetForm();
              this.v$.$reset();
            }, 0);
            this.getResults();
          })
          .finally(() => {
            this.$nextTick(() => {
              this.isSubmitted = false;
              this.showModalEdit = false;
            });
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.sub-title h3 {
  font-weight: 600;
    font-size: 14px;
    margin-bottom: 10px;
}
.modal-article .indice {
  margin-left: 0;
  margin-top: 5px;
}
</style>

